import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';

// Components
import { UnsavedChangesComponent } from './components/unsaved-changes.component';
import { HeaderComponent } from './components/header/header.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { OutletInfoComponent } from './components/outlet-info/outlet-info.component';
import { GoogleAddressComponent } from './components/google-address/google-address.component';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';

// Pipes
import { GenderPipe, SafeUrlPipe } from './pipes';

// Directives
import {
  DecimaNumberDirective,
  OnlyNumberDirective,
  PhoneNumberDirective,
  PaginatorA11yDirective,
  DialogA11yDirective
} from './directives';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
  ],
  declarations: [
    UnsavedChangesComponent,
    HeaderComponent,
    ErrorPageComponent,
    OutletInfoComponent,
    GoogleAddressComponent,
    GenderPipe,
    SafeUrlPipe,
    DecimaNumberDirective,
    OnlyNumberDirective,
    PhoneNumberDirective,
    PaginatorA11yDirective,
    DialogA11yDirective,
    OtpVerificationComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule,

    //Components
    HeaderComponent,
    ErrorPageComponent,
    OutletInfoComponent,
    GoogleAddressComponent,
    OtpVerificationComponent,
    
    //Pipes
    GenderPipe,
    SafeUrlPipe,

    //Directives
    DecimaNumberDirective,
    OnlyNumberDirective,
    PhoneNumberDirective,
    PaginatorA11yDirective,
    DialogA11yDirective
  ],
  providers: [],
  entryComponents: [UnsavedChangesComponent],
})
export class SharedModule {}
